export const allSettled = promises => {
  const wrappedPromises = promises.map(p =>
    Promise.resolve(p).then(
      val => ({ status: "fulfilled", value: val }),
      err => ({ status: "rejected", reason: err })
    )
  );
  return Promise.all(wrappedPromises);
};

export const delayedRejectablePromise = (promise, delay) => {
  let resolvePromise;
  let rejectPromise;

  const resultantPromise = new Promise((resolve, reject) => {
    resolvePromise = resolve;
    rejectPromise = reject;
    setTimeout(() => {
      rejectPromise("timeout");
    }, delay);
  });

  promise.then(data => resolvePromise(data)).catch(error => rejectPromise(error));

  return resultantPromise;
};
